import { LogOut, RefreshCw } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/auth-context";
import { api } from "@/lib/api/services";
import { getUserFacingErrorKey } from "@/lib/api/errors";
import { type TranslationKey, useT } from "@/lib/i18n";
import { Button } from "./ui/button";

export function ActivationGate() {
  const auth = useAuth();
  const navigate = useNavigate();
  const t = useT();
  const [pending, setPending] = useState<"resend" | "refresh" | "logout" | null>(null);
  const [feedback, setFeedback] = useState<{ type: "success" | "error"; message: TranslationKey } | null>(null);

  async function resend() {
    setPending("resend"); setFeedback(null);
    try { await api.resendEmail(); setFeedback({ type: "success", message: "auth.resent" }); }
    catch (error) { setFeedback({ type: "error", message: getUserFacingErrorKey(error) }); }
    finally { setPending(null); }
  }

  async function refresh() {
    setPending("refresh"); setFeedback(null);
    try { await auth.refreshSession(); }
    catch (error) { setFeedback({ type: "error", message: getUserFacingErrorKey(error) }); }
    finally { setPending(null); }
  }

  async function logout() {
    setPending("logout");
    try {
      await auth.logout();
      await navigate("/", { replace: true, viewTransition: true });
    } catch (error) { setFeedback({ type: "error", message: getUserFacingErrorKey(error) }); }
    finally { setPending(null); }
  }

  return <main className="activation-page"><section className="activation-card"><span className="eyebrow">{t("auth.email_verification")}</span><h1>{t("auth.verify_email_title")}</h1><p>{t("auth.verify_email_desc")}</p>{feedback ? <div className={feedback.type === "success" ? "inline-alert inline-alert--success" : "inline-alert"} role="status">{t(feedback.message)}</div> : null}<div className="activation-actions"><Button size="large" disabled={pending !== null} onClick={() => void refresh()}><RefreshCw size={17} />{pending === "refresh" ? t("auth.checking") : t("auth.email_confirmed_button")}</Button><Button variant="secondary" disabled={pending !== null} onClick={() => void resend()}>{pending === "resend" ? t("auth.sending") : t("auth.resend_email")}</Button><Button variant="ghost" disabled={pending !== null} onClick={() => void logout()}><LogOut size={17} /> {t("header.logout")}</Button></div></section></main>;
}
